<template>
  <div />
</template>

<script>
export default {
  name: 'ConferenceRedirect',
  props: {
    slug: { type: String, required: true }
  },
  created() {
    this.$router.replace({ name: `conference-${this.$i18n.locale}`, params: { slug: this.slug } })
  }
}
</script>
